import { Form, Input } from "antd";
import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";

export default function EditAbsenceType() {
  const data = useLoaderData();
  const loadFn = (form) => form.setFieldsValue(data);
  return (
    <SimpleFormPage title="Modifica categoria assenza" loadFn={loadFn}>
      <Form.Item label="ID" name="id">
        <Input disabled />
      </Form.Item>
      <Form.Item label="Nome" name="name">
        <Input />
      </Form.Item>
    </SimpleFormPage>
  );
}
